import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, SearchX, Instagram, Users, CalendarX, Moon } from 'lucide-react';
import { revealVariants, staggerContainer, itemVariants } from '../utils/animations';
const problems = [{
  icon: ShieldAlert,
  text: 'Sin web no transmitís confianza'
}, {
  icon: SearchX,
  text: 'No aparecés en Google'
}, {
  icon: Instagram,
  text: 'Tu Instagram no alcanza'
}, {
  icon: Users,
  text: 'Tu competencia parece más profesional'
}, {
  icon: CalendarX,
  text: 'Perdés reservas'
}, {
  icon: Moon,
  text: 'Perdés ventas mientras dormís'
}];
export function ProblemSection() {
  return <section className="py-20 md:py-32 relative" data-id="element-322">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-323">
        <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-20" data-id="element-324">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-white mb-6" data-id="element-325">
            Tu negocio pierde clientes <br className="hidden md:block" data-id="element-326" /> todos
            los días.
          </h2>
          <p className="text-xl text-neutral-400 font-light max-w-2xl mx-auto" data-id="element-327">
            Hoy las personas juzgan tu negocio antes de hablarte.
          </p>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-328">
          {problems.map((problem, idx) => <motion.div key={idx} variants={itemVariants} className="group relative p-6 sm:p-8 rounded-2xl bg-white/[0.02] border border-white/5 hover:border-electric/40 transition-colors duration-500 overflow-hidden" data-id="element-329">
              <div className="absolute inset-0 bg-gradient-to-br from-electric/0 via-neon/0 to-cyan/15 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-330"></div>

              <div className="relative z-10" data-id="element-331">
                <div className="w-12 h-12 rounded-full bg-neutral-900 border border-white/10 flex items-center justify-center mb-6 group-hover:border-electric/40 transition-colors duration-500" data-id="element-332">
                  <problem.icon size={20} className="text-neutral-400 group-hover:text-cyan transition-colors duration-500" data-id="element-333" />
                </div>
                <h3 className="text-xl font-medium text-neutral-200 group-hover:text-white transition-colors duration-500" data-id="element-334">
                  {problem.text}
                </h3>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}